import React from 'react';
import { Typography } from 'antd';
import { getLegendStops } from '../../utils/colorScale';
import './styles.css';

const { Text } = Typography;

const Legend = () => {
  const stops = getLegendStops();

  return (
    <div className="legend-container">
      <Text className="legend-title">Intensità Viaggi</Text>
      {/* Detailed stops */}
      <div className='legend-sub-container'>
        <div className="legend-stops">
          {stops.map((stop, index) => (
            <div key={index} className="legend-stop">
              <div
                className="legend-stop-color"
                style={{ backgroundColor: stop.color }}
              />
              <span className="legend-stop-label">{stop.label}</span>
            </div>
          ))}
        </div>

        {/* Legend for origin/destination */}
        <div className="legend-selection">
          <div className="legend-selection-item">
            <div
              className="legend-selection-color"
              style={{ backgroundColor: '#4CAF50' }}
            />
            <span>Origine</span>
          </div>
          <div className="legend-selection-item">
            <div
              className="legend-selection-color"
              style={{ backgroundColor: '#2196F3' }}
            />
            <span>Destinazione</span>
          </div>
          <div className="legend-selection-item">
            <div
              className="legend-selection-color"
              style={{ backgroundColor: '#d3d3d3', border: '1px solid #808080' }}
            />
            <span>Nessun Dato</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legend;
